import { useReactions, REACTION_EMOJIS, REACTION_LABELS, ReactionType } from '../../features/blogs/hooks/useReactions';

const REACTION_TYPES: ReactionType[] = ['clap', 'heart', 'fire', 'insightful'];

interface ReactionBarProps {
  blogSlug: string;
  postSlug: string;
}

export function ReactionBar({ blogSlug, postSlug }: ReactionBarProps) {
  const { counts, myReactions, loading, toggle } = useReactions(blogSlug, postSlug);

  return (
    <div
      className="flex flex-wrap items-center gap-2 py-4"
      role="group"
      aria-label="Post reactions"
    >
      {REACTION_TYPES.map(type => {
        const isActive = myReactions.includes(type);
        const count = counts[type];
        return (
          <button
            key={type}
            type="button"
            onClick={() => toggle(type)}
            disabled={loading}
            aria-pressed={isActive}
            aria-label={`${REACTION_LABELS[type]}: ${count}`}
            title={REACTION_LABELS[type]}
            className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-full text-sm font-medium
              border transition-all duration-150 active:scale-95 select-none
              ${isActive
                ? 'border-primary/50 bg-primary/10 text-primary'
                : 'border-border bg-background text-muted-foreground hover:border-primary/30 hover:text-foreground hover:bg-muted'
              }
              ${loading ? 'opacity-50 pointer-events-none' : ''}`}
          >
            <span role="img" aria-hidden="true" className="text-base leading-none">
              {REACTION_EMOJIS[type]}
            </span>
            {count > 0 && (
              <span className="tabular-nums">{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
